import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'The Method', path: '/method' },
    { name: 'The School', path: '/school' },
    { name: 'Founder', path: '/founder' },
    { name: 'Private Coaching', path: '/coaching' },
    { name: 'Children\'s Coaching', path: '/children-coaching' },
    { name: 'Professional Pathways', path: '/pathways' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Apply', path: '/apply' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-page border-b border-border-light">
      <div className="container-custom">
        <div className="flex justify-between items-center py-6">
          {/* Logo */}
          <Link to="/" className="logo-text">
            GPS METHOD™
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${
                  location.pathname === item.path ? 'active' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-primary p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden pb-6 border-t border-border-light mt-4 pt-4">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`block py-3 nav-link ${
                  location.pathname === item.path ? 'active' : ''
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;